import type { ComponentProps } from 'react';

import { Checkbox as ShadcnCheckbox } from '@/lib/shadcn/checkbox';

export function Checkbox({ ...props }: ComponentProps<typeof ShadcnCheckbox>) {
  return <ShadcnCheckbox {...props} />;
}
